import React, { useEffect, useState } from "react";
import mondaySdk from "monday-sdk-js";
import { useLocation } from "react-router-dom";
import "@vibe/core/tokens";
import UpdateVersion from "./update/new_version";
import ErrorPage from "../components/errorPage";
import PageLoader from "../components/PageLoader";
import useBoardAndItems from "../hooks/context/useBoardAndItems";
import useUser from "../hooks/context/userHook";
import AddItemDropdown from "../components/addItem/AddItemDropdown";
import { MondayApiQueryInstance } from "../services/monday/monday-service-ts";
import { WarningFilled } from "@ant-design/icons";
import { useCalcComplexity } from "../hooks/utils";
import { complexityConstants } from "../data/constants/complexityConstants";
import { Modal, ModalHeader, ModalContent, ModalFooter, ModalBasicLayout } from "@vibe/core/next";
import { useErrorWebsocket } from "../hooks/services";
import { useCheckUserOnboarding } from "../hooks/api/useCheckUserOnboarding";

const monday = mondaySdk();

const BatchItemMenu = () => {
  const { userId } = useUser();
  const { itemIds } = useBoardAndItems();
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [version, setVersion] = useState(false);
  const [bigAccount, setBigAccount] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [disableAll, setDisableAll] = useState(false);
  const location = useLocation();
  const tourState = location.state?.tour;

  const { isAuthorized, error } = useCheckUserOnboarding(userId);

  monday.execute("valueCreatedForUser");

  const { complexityUsed, batchSize, moreThan20 } = useCalcComplexity(itemIds ?? []);

  useEffect(() => {
    if (complexityUsed >= complexityConstants.maxComplexity) {
      setIsModalOpen(true);
      setDisableAll(true);
    }
  }, [complexityUsed]);

  useErrorWebsocket(userId ? String(userId) : "");

  useEffect(() => {
    const fetchAccountSize = async () => {
      try {
        const checkAccountSize = localStorage.getItem("isBigAccount");

        if (checkAccountSize !== null) {
          setBigAccount(JSON.parse(checkAccountSize));
        } else {
          const boardSize = await MondayApiQueryInstance.getAccountSize();

          const isBigAccount = boardSize.length >= 500;

          localStorage.setItem("isBigAccount", JSON.stringify(isBigAccount));
          setBigAccount(isBigAccount);
        }
      } catch (error) {
        throw error;
      }
    };

    fetchAccountSize();
  }, []);

  useEffect(() => {
    monday.execute("valueCreatedForUser");
    monday.get("context").then((res) => {
      let dataVersion = res.data.appVersion.versionData.major;
      //version for force update

      //make the app true
      parseInt(dataVersion) < 27 ? setVersion(false) : setVersion(false);
      res.data.user.isViewOnly ? setIsViewOnly(true) : setIsViewOnly(false);
      let itemidsArray = [];
      res.data.appFeature.type === "AppFeatureItemBatchAction"
        ? (itemidsArray = res.data.selectedPulsesIds)
        : itemidsArray.push(res.data.itemId);
    });
  }, []);
  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  if (Array.isArray(itemIds) && itemIds.length > 100) {
    return (
      <div className="flex flex-col justify-center items-center p-7 h-screen text-center">
        <div className="mb-2">
          <WarningFilled className="text-warning-color text-[128px]" />
        </div>
        <p className="text-balance">You can only select 100 items at a time.</p>
      </div>
    );
  }

  return (
    <div>
      {isViewOnly ? (
        <div className="flex justify-center items-center h-screen">
          <div className="px-4 py-3 bg-red-100 rounded">
            <span className="block sm:inline">As a viewer, you are unable to use the SIMB.</span>
          </div>
        </div>
      ) : !error ? (
        itemIds && isAuthorized ? (
          version ? (
            <UpdateVersion />
          ) : (
            <div className="w-full h-screen">
              <AddItemDropdown
                centered={false}
                fullWidth={true}
                bigAccount={bigAccount}
                batchSize={batchSize}
                disableAll={disableAll}
                moreThan20={moreThan20}
                stepsEnabled={tourState}
              />

              {isModalOpen && (
                <Modal id="story-book-modal" onClose={closeModal} show={isModalOpen} size="medium">
                  <ModalBasicLayout>
                    <ModalHeader title="Limit reached." className="px-8" />
                    <ModalContent>
                      <p>
                        If you continue some items will not be processed. Please remove some items
                        or do not include the subitems when adding to another board
                      </p>
                    </ModalContent>
                  </ModalBasicLayout>
                  <ModalFooter
                    primaryButton={{
                      onClick: () => {
                        closeModal();
                      },
                      text: "Close",
                    }}
                  />
                </Modal>
              )}
            </div>
          )
        ) : (
          <div className="App">
            <PageLoader />
          </div>
        )
      ) : (
        <ErrorPage />
      )}
    </div>
  );
};

export default BatchItemMenu;
